import { createVNode, mergeProps } from "vue";
export default {
  name: 'InstagramIcon',
  props: {
    size: {
      type: String,
      default: '16',
      validator: s => !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x'
    }
  },

  setup(props, ctx) {
    const size = props.size.slice(-1) === 'x' ? props.size.slice(0, props.size.length - 1) + 'em' : parseInt(props.size) + 'px';
    const attrs = { ...ctx.attrs
    };
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    return () => createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "class": "feather feather-instagram"
    }, { ...attrs
    }), [createVNode("rect", {
      "x": "2",
      "y": "2",
      "width": "20",
      "height": "20",
      "rx": "5",
      "ry": "5"
    }), createVNode("path", {
      "d": "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"
    }), createVNode("line", {
      "x1": "17.5",
      "y1": "6.5",
      "x2": "17.51",
      "y2": "6.5"
    })]);
  }

};